"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeWebTracking = exports.track = void 0;
const utils_1 = require("./utils");
const webTrackingUniversalData = {
    isInitialized: false,
    authToken: '',
    buildingUuid: '',
    appUuid: '',
    userAgent: '',
    clientApiUrl: 'https://www.hqoapp.com',
};
const track = async (eventName, extraMetadata, config = { sendToPendo: true }) => {
    if (!webTrackingUniversalData.isInitialized) {
        console.warn('Web tracking has not been initialized');
        return;
    }
    const metadata = Object.assign(Object.assign(Object.assign({ timestamp: Date.now() }, extraMetadata), webTrackingUniversalData.bootstrappedMetadata), { type: extraMetadata.type, building_uuid: webTrackingUniversalData.buildingUuid, app_uuid: webTrackingUniversalData.appUuid, user_agent: webTrackingUniversalData.userAgent });
    const isMetadataValid = await (0, utils_1.validateMetadata)(metadata);
    if (isMetadataValid) {
        if (config.sendToHqoTracking) {
            (0, utils_1.handleHqOTracking)(webTrackingUniversalData.clientApiUrl, webTrackingUniversalData.authToken, eventName, metadata);
        }
        if (config.sendToPendo) {
            (0, utils_1.handlePendoTracking)(eventName, metadata);
        }
    }
};
exports.track = track;
const initializeWebTracking = async (authToken, currentBuildingUuid, appUuid, userAgent, clientApiUrl, bootstrappedMetadata = {}) => {
    if (authToken === '') {
        console.warn('User does not have an authToken: ', authToken);
        return;
    }
    webTrackingUniversalData.authToken = authToken;
    if (currentBuildingUuid === '') {
        console.warn('Current building uuid is invalid: ', currentBuildingUuid);
        return;
    }
    webTrackingUniversalData.buildingUuid = currentBuildingUuid;
    if (appUuid === '') {
        console.warn('Current app uuid is invalid: ', appUuid);
        return;
    }
    webTrackingUniversalData.appUuid = appUuid;
    if (userAgent === '') {
        console.warn('Current user agent is missing: ', userAgent);
        return;
    }
    webTrackingUniversalData.clientApiUrl = clientApiUrl;
    webTrackingUniversalData.userAgent = userAgent;
    webTrackingUniversalData.bootstrappedMetadata = bootstrappedMetadata;
    webTrackingUniversalData.isInitialized = true;
};
exports.initializeWebTracking = initializeWebTracking;
//# sourceMappingURL=index.js.map